import { render, staticRenderFns } from "./CompanyOrganism.vue?vue&type=template&id=3df470a8&scoped=true&"
import script from "./CompanyOrganism.vue?vue&type=script&lang=js&"
export * from "./CompanyOrganism.vue?vue&type=script&lang=js&"
import style0 from "./CompanyOrganism.vue?vue&type=style&index=0&id=3df470a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df470a8",
  null
  
)

export default component.exports